import { PlusInSquareIcon } from "assets/icons";
import { ChartRangeType } from "components";
import { getEndOfDateByTimeUnit, getStartOfDateByTimeUnit } from "helpers";
import { useBoolean } from "hooks";
import { ContentLayout } from "layouts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "ui";

import { useInternalBank } from "../../apis";
import {
  BalanceLabel,
  InternalBankHistoryTable,
  InternalBankStatistic,
  ReplenishInternalBankModal
} from "../../components";

import styles from "./InternalBank.module.scss";

const InternalBank = () => {
  const { t } = useTranslation();

  const { internalBank } = useInternalBank();

  const [dateRange, setDateRange] = useState<[Date, Date]>([
    getStartOfDateByTimeUnit(new Date(), ChartRangeType.Week),
    getEndOfDateByTimeUnit(new Date(), ChartRangeType.Week)
  ]);

  const {
    value: isReplenishModalOpen,
    setTrue: openReplenishModal,
    setFalse: closeReplenishModal
  } = useBoolean(false);

  return (
    <ContentLayout
      title={t("Internal Bank")}
      action={
        <div className={styles.balance}>
          <BalanceLabel label="Balance" balance={internalBank?.amount} />
          <Button onClick={openReplenishModal} icon={<PlusInSquareIcon />}>
            {t("Replenish")}
          </Button>
        </div>
      }
    >
      <InternalBankStatistic
        dateRange={dateRange}
        setDateRange={setDateRange}
      />

      <InternalBankHistoryTable dateRange={dateRange} />

      {isReplenishModalOpen && (
        <ReplenishInternalBankModal
          isOpen={isReplenishModalOpen}
          onClose={closeReplenishModal}
        />
      )}
    </ContentLayout>
  );
};

export default InternalBank;
